import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ImportPage from '../pages/Import/ImportPage';
import ProtectedRouteV2 from './ProtectedRouteV2';

const importRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/imports"
      element={
        <>
          <PageTitle title="Importación | Sistema de Administración" />
          <ImportPage />
        </>
      }
    />
  </Route>
);

export default importRoutes;
